<template>
  <div class="d-flex align-center pl-3">
    <button class="btn btn-primary" @click="startExam()">
      <span class="exam-icon" v-if="icon" v-html="icon"></span>

      <span class="exam-btn-txt">{{ btnText }}</span>
    </button>
  </div>
</template>

<script>
export default {
    name: 'ExamButton',
    props: ['btnText', 'icon'],
    computed: {
      isGold() {
        return this.$store.getters['user/isGold']
      },
    },
    data(){
      return {
      }
    },
    methods: {
      async startExam() {
        if (this.isGold) {
          const response = await this.$client.get('user/exam-link')
          if (response.data.status) {
            window.open(response.data.data.redirect_url, '_blank');
          } else {
            this.$fire({
              text: "Ինչ որ բան սխալ գնաց, խնդրում եմ փորձեք մի փոքր ուշ",
              type: "info",
              confirmButtonText: 'Լավ'
            })
          }
        } else {
          this.$fire({
            text: "Հասանելի է Գոլդ փաթեթի օգտատերերին",
            type: "info",
            confirmButtonText: 'Լավ'
          })
        }
      }
    }
};
</script>

